<template>
  <div>
    <div v-if="component404">
      <h5>Resource not found</h5>
    </div>
    <transition name="slide-fade">
      <div
        v-if="!componentLoading"
        id="scenario-view"
        class="scenario shadow rounded bg-white mx-1"
      >
        <div class="px-5 p-4">
          <div class="d-flex flex-row align-items-center mb-4">
            <i class="material-icons material-icons-title mr-2">insert_chart_outlined</i>
            <h2 class="mt-2">{{scenario.name}}</h2>
          </div>
          <div class="row">
            <div class="col-12 col-md-5 d-flex flex-column left-side">
              <div class="device-thumb-wrapper d-flex justify-content-center">
                <img class="device-thumb" :src="deviceThumb" title />
              </div>
              <div class="mt-3">
                <ScenarioActions
                  :uuidId="scenario.uuid_id"
                  :isFavouritedByUser="isFavouritedByUser"
                ></ScenarioActions>
              </div>
              <div class="align-self-start d-flex justify-content-between">
                <div class="flex-start align-self-start">
                  <div class="scenario-stats my-2 d-flex flex-column">
                    <div v-if="scenario.contributed_by" class="d-flex align-items-center">
                      <i class="material-icons text-secondary">person</i>
                      <em>Contributed By:</em>
                      <router-link
                        :to="{ name: 'view-user', params: { id: scenario.contributed_by.uuid_id} }"
                      >
                        <span
                          class="element-label"
                        >{{scenario.contributed_by.is_public ? scenario.contributed_by.publicUsername : 'Anonymous User'}}</span>
                      </router-link>
                    </div>
                    <div class="d-flex align-items-center">
                      <i class="material-icons text-secondary">star</i>
                      <em>Favourited:</em>
                      <span class="element-label">
                        <em>{{ scenario.number_favourites }}</em>
                      </span>
                    </div>
                    <div class="d-flex align-items-center">
                      <i class="material-icons text-secondary">save_alt</i>
                      <em>Downloads:</em>
                      <span class="element-label">
                        <em>{{ scenario.num_downloads }}</em>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-7 d-flex flex-column justify-content-around">
              <div
                class="patient-image-wrapper d-flex justify-content-center justify-content-md-start"
              >
                <img :src="patientPhoto" title class="patient-photo rounded-circle" />
              </div>
              <div class="my-3">{{ scenario.description }}</div>

              <ul
                v-if="scenario.tags"
                class="p-0 scenario-tags d-flex justify-content-start flex-wrap my-3"
              >
                <li
                  v-bind:key="tag.id"
                  v-for="tag in tags"
                  v-bind:class="{ selected: tag.isCurrentlySelected }"
                >{{ tag.title }}</li>
              </ul>
            </div>
          </div>
        </div>
        <div v-if="scenario" class="d-none d-sm-block col-12 align-self-end mt-3 bg-light">
          <ScenarioElements
            bind:fileSize="fileSize"
            :language="scenario.unicode_language_identifier"
            :durationInSeconds="scenario.duration_in_seconds"
            :numChecklistItems="scenario.num_checklist_items"
            :numEvents="scenario.num_events"
            :hasMedia="scenario.has_images"
            :hasSounds="scenario.has_sounds"
            :hasLabs="scenario.has_labs"
          ></ScenarioElements>
        </div>
      </div>
    </transition>
    <div v-if="componentLoading" class="please-wait">
      <PleaseWait></PleaseWait>
    </div>
  </div>
</template>

<script>
import ScenarioActions from "../components/ScenarioActions";
import ScenarioService from "../services/scenarios.service";
import ScenarioHelper from "../utils/scenario.helper";
import ScenarioElements from "../components/ScenarioElements";
import PleaseWait from "../components/PleaseWait";
import { store } from "../store/store";

export default {
  name: "ScenarioView",
  computed: {
    appLoading() {
      return this.$store.getters.getAppLoading;
    }
  },
  data: function() {
    return {
      componentLoading: true,
      component404: false,
      scenario: {},
      isFavouritedByUser: false,
      deviceThumb: require("../assets/device/" +
        ScenarioHelper.getFilenameForDeviceThumb(this.deviceId)),
      patientPhoto: require("../assets/patient-photos/" +
        ScenarioHelper.getFilenameForPatientPhoto(this.patientPhotoId))
    };
  },

  watch: {
    "$route.params.uuidId": function() {
      this.scenario = {};
      this.getScenarios(this.$route.params.uuidId);
    }
  },
  components: {
    ScenarioActions,
    ScenarioElements,
    PleaseWait
  },

  methods: {
    getScenarios(uuidId) {
      this.$store.commit("setViewingScenarioId", this.$route.params.uuidId);
      this.componentLoading = true;
      ScenarioService.scenario(uuidId)
        .then(data => {
          this.scenario = data;
          vm.$data.currentScenairo = this.scenario.uuidId;
          this.tags = data.tags;
          this.isFavouritedByUser = data.is_favourited_by_current_user;
          this.deviceThumb = require("../assets/device/" +
            ScenarioHelper.getFilenameForDeviceThumb(this.scenario.device_id));
          this.patientPhoto = require("../assets/patient-photos/" +
            ScenarioHelper.getFilenameForPatientPhoto(this.patientPhotoId));
          this.componentLoading = false;
          this.setRouteParams(this.scenario.name);
        })
        .catch(error => {
          if (error.message.includes("404")) {
            this.component404 = true;
          }
        });
    },
    updateFavouriteScenariosList() {
      this.$parent.updateFavouriteScenariosList();
    },

    setRouteParams(param) {
      this.$route.meta.breadcrumb.label = param;
      this.$router.replace({ query: { temp: Date.now() } });
      this.$router.replace({ query: { temp: undefined } });
    }
  },

  beforeMount() {
    this.scenario = {};
    this.getScenarios(this.$route.params.uuidId);
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("setViewingScenarioId", "");
    next();
  }
};
</script>

<style scoped>
.scenario-container {
  padding: 0.75rem 1.25rem;
  background-color: #fff;

  border-radius: 0.25rem;
  min-height: 100vh;
}

.scenario-elements {
  padding: 0;
  margin: 0;
}
.scenario-elements li {
  display: inline-block;
  height: 50px;
}
.scenario-tags li {
  margin-right: 10px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.scenario-elements li i {
  margin-right: 5px;
}

li .tiny-span {
  font-size: 12px;
  color: #CB2E37;
}

.patient-photo {
  max-height: 125px;
  width: auto;
}

.device-thumb {
  height: auto;
  width: auto;
  max-width: 250px;
}

.material-icons-title {
  font-size: 50px;
  color: #7d7d7d;
}

.please-wait {
  height: 60vh;
}
</style>
